var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.containerText},[_vm._v("\n    "+_vm._s(_vm.learnMore)+"\n  ")]),_vm._v(" "),_c('div',{class:_vm.$style.containerImage},[_c('svg-arrow-2')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }